import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { SearchProvider } from "./contexts/SearchContext";
import { EnrichmentProvider } from "./contexts/EnrichmentContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Privacy from "./pages/Privacy";
import Impressum from "./pages/Impressum";
import AcceptInvite from "./pages/AcceptInvite";
import Dashboard from "./pages/Dashboard";
import Reports from "./pages/Reports";
import Export from "./pages/Export";
import Team from "./pages/Team";
import Admin from "./pages/Admin";
import Settings from "./pages/Settings";

// Layout
import AppLayout from "./components/layout/AppLayout";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          {/* P6.7: privacy policy is public — readable while logged out or pending */}
          <Route path="/privacy" element={<Privacy />} />
          {/* CL-LEGAL-IMPRESSUM-001: legal notice is public — readable while logged out */}
          <Route path="/impressum" element={<Impressum />} />
          {/* PILOT-ACCESS-003A: public account activation from a personal invitation (token in
              the #fragment, removed from the address bar on load). */}
          <Route path="/accept-invite" element={<AcceptInvite />} />
          
          {/* Protected routes */}
          {/* P9: SearchProvider wraps the layout route element, so it is mounted once for the
              whole authenticated session and survives navigation between the child routes
              below (only the <Outlet /> subtree swaps). AppLayout is inside it so the global
              running-search indicator can read the state. */}
          {/* 2.0X: EnrichmentProvider sits beside SearchProvider and for the identical
              reason — mounted once on the layout route, it survives navigation between the
              child routes, so an enrichment started on the Dashboard keeps running when the
              panel closes or the user goes elsewhere. */}
          <Route element={(
            <SearchProvider>
              <EnrichmentProvider>
                <AppLayout />
              </EnrichmentProvider>
            </SearchProvider>
          )}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/export" element={<Export />} />
            <Route path="/team" element={<Team />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
          
          {/* Redirect root to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          {/* Catch all - redirect to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
